import * as React from 'react';

interface IFormattedStringProps {
  className?: string;
  string: string;
  tagName: string;
  values: { [key: string]: string | number | undefined }
}

export function FormattedString(props: IFormattedStringProps) {
  const { string, tagName, values, ...rest } = props;

  let formattedString = string;
  for (const [key, replacement] of Object.entries(values)) {
    if (replacement) {
      const strReplacement = typeof replacement === 'number'
        ? replacement.toString()
        : replacement;
      formattedString = formattedString.replace(`{${key}}`, strReplacement);
    }
  }

  if (tagName === 'fragment') {
    return React.createElement(React.Fragment, null, formattedString);
  }

  return React.createElement(tagName, { ...rest }, formattedString);
}
